import React from 'react';
import Text from '@/components/Text/Text';
import IngredientList from '@/page-components/Ingredients/IngredientList';
import styles from './IngredientCards.module.scss';
import { IngredientsData } from '@/page-components/Ingredients/api';

interface IngredientCardsProps {
  data: {
    title: string;
  },
  ingredients: IngredientsData[];
}

const IngredientCards = ({ data, ingredients }:IngredientCardsProps) => (
  <section className={styles.ingredientCards}>
    <Text
      tag='h2'
      className={styles.title}
    >
      {data.title}
    </Text>

    <IngredientList
      className={styles.gridList}
      list={ingredients}
      loading={false}
      currentPage={1}
    />
  </section>
);

export default IngredientCards;
